'use strict';
angular.module('resCenDigitalModule', ['resCenDigitalnewsLeftModule', 'resDigitalnewsRouter']).controller('resDigitalCtrl', [
    '$scope',
    '$stateParams',
    '$element',
    '$timeout',
    'trsHttpService',
    'globleParamsSet',
    'resCtrModalService',
    'trsspliceString',
    '$q',
    'modalDialog',
    'resourceCenterService',
    'trsPrintService',
    'initComDataService',
    '$filter',
    '$state',
    'storageListenerService',
    function (
        $scope,
        $stateParams,
        $element,
        $timeout,
        trsHttpService,
        globleParamsSet,
        resCtrModalService,
        trsspliceString,
        $q,
        modalDialog,
        resourceCenterService,
        trsPrintService,
        initComDataService,
        $filter,
        $state,
        storageListenerService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.childStatus = {
                // 图片数组的string
                checkString: 'imgurl',
                // 图片数组中表示url地址的string
                picString: 'urlS',
                originPicUrl: 'urlM'
            };
            $scope.basicParams = {
                channelName: 'szb',
                indexName: '',
            };
            // 分页信息
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.setResourceCenterPageSize,
            };
            // 列表查询基本参数,固定参数
            $scope.params = {
                typeid: 'zyzx',
                serviceid: 'szb',
                modelid: 'findFromNavigation',
                pageSize: $scope.page.PAGESIZE, // 每页条数
                pageNum: $scope.page.CURRPAGE, // 当前页
                keyword: '',
            };
            // 检索词参数
            $scope.keyword = {
                searchType: '0', // 查询类型，0全部1标题2作者
                keywords: '', // 关键字
                time: '', // 时间
                area: '', // 地域
                zyzxfield: '', // 主题
                isOriginal: '', // 是否原创
                isHead: '', // 是否头版
                isRead: '', // 是否10W+ 0否  1是
                menuscriptType: '0', // 稿件类型 0全部 1文字 2图片
                mediaName: $state.params.medianame,
            };
            // 导航栏获取信息
            var paramsArray = $stateParams.param_data ? $stateParams.param_data.split('&') : [];
            for (var i in paramsArray) {
                var attribute = paramsArray[i].toLowerCase();
                $scope.params[attribute] = $stateParams[attribute];
            }
            // 初始化数据
            $scope.data = {
                items: [], // 列表数据
                casDataArea: [], // 地区的级联数组
                themeType: {}, // 主题参数
                keyType: {}, // 搜索词的类型
                selectedArray: [], // 当前的选择项
                currPage: 1, // 当前页数
                docType: {
                    // 稿件类型
                    data: [],
                    curValue: {},
                },
                itemCounts: 0, // 显示的稿件数量
            };
            // 头部选框数据
            $scope.headerClick = {
                typeid: 'zyzx',
                serviceid: 'mlf_bigdataexchange',
                channelName: $scope.basicParams.channelName,
                indexName: $scope.basicParams.indexName,
            };
            resourceCenterService.setSzbPage(true);
            $scope.status = {
                // isSzbPage: false, //是否为数字报版面布局
                isSzbPage: resourceCenterService.getSzbPage(), // 是否为数字报版面布局
                isSzbTipShow: true, // 是否显示数字报点击按钮
                screenWrapSelected: false, // 是否显示更多筛选
                singleGraph: false, // 是否为单图模式
                hasphoto: false, // 是否显示图集
                isrepetite: false,
                isHead: false, // 是否头版
                Only: false, // 暂时无加排重
                multiImgsReady: false, // 多图加载完成
            };
            // if ($stateParams.media_id) {
            //     $scope.status.isSzbTipShow = true;
            // } else {
            //     $scope.status.isSzbTipShow = false;
            // }
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            listenStorage();
            initDropDown().then(function () {
                if ($scope.$root && $scope.$root.filterDataBack) {
                    // 判断是否有传递的数据
                    var filterDataBack = angular.copy($scope.$root.filterDataBack);
                    $scope.page = filterDataBack.page;
                    $scope.data.fromdate = filterDataBack.fromdate;
                    $scope.data.untildate = filterDataBack.untildate;
                    $scope.keyword = $scope.params.keyword = filterDataBack.paramsKeyword;
                    $scope.params.pageNum = $scope.page.CURRPAGE;
                    $scope.params.pageSize = $scope.page.PAGESIZE;
                    $scope.docType = filterDataBack.docType; // 当前稿件类型
                    $scope.themeType = filterDataBack.themeType; // 当前主题
                    $scope.keyType = filterDataBack.keyType; // 当前检索信息
                    $scope.status.isHead = filterDataBack.isHead; // 只看头版
                    $scope.keywords = $scope.params.keyword.keywords;
                    // 默认展开更多筛选项
                    if ($scope.docType.curValue.value != '' || $scope.themeType.curValue.id != '' || filterDataBack.area != undefined) {
                        $scope.status.screenWrapSelected = true;
                    }
                    if (filterDataBack.area) {
                        $scope.data.casDataArea.push(filterDataBack.area[0]);
                        $scope.data.area = filterDataBack.area;
                    }
                    if (filterDataBack.listData) {
                        // 是否图集稿，是则直接传递图集列表数据
                        $scope.status.hasphoto = true;
                        $timeout(function () {
                            $scope.data.items = filterDataBack.listData;
                            initOperFlag();
                        }, 100);
                        $scope.status.singleGraph = filterDataBack.singleGraph; // 是否单图
                        storageListenerService.previewPageTurningStorage(filterDataBack.listData, 'ZB_GUID', 'resourceDetail');
                    } else {
                        requestData();
                    }
                    $timeout(function () {
                        $scope.$on('$destroy', function () {
                            // 销毁对象
                            delete $scope.$root.filterDataBack;
                        });
                    });
                } else {
                    requestData();
                }
            });
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function () {
                requestData();
                storageListenerService.removeListener('resource');
            }, $scope);
        }

        /**
         * [initDropDown description] 类型下拉框初始化
         * @return {[type]} [description]
         */
        function initDropDown() {
            var defer = $q.defer();
            // 全部稿件
            $scope.data.docType = {
                data: initComDataService.resourceCenterNewsType(),
                curValue: initComDataService.resourceCenterNewsType()[0],
            };
            // 检索字段
            $scope.data.keyType = {
                data: initComDataService.searchBigdataType(),
                curValue: initComDataService.searchBigdataType()[0],
            };
            // 所有主题
            var themeParams = {
                serviceid: 'navigation',
                typeid: 'zyzx',
                modelid: 'base',
                parentId: '-1',
                level: '2',
                excludeId: '-1',
                containParent: false,
                channelName: 'szb',
                typeName: 'zyzxfield',
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), themeParams, 'post').then(function (themeData) {
                $scope.data.themeType = {
                    data: [
                        {
                            dictName: '所有主题',
                            id: '',
                        },
                    ].concat(themeData),
                    curValue: {
                        dictName: '所有主题',
                        id: '',
                    },
                };
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [showSelectedArea description：数据地域信息的级联菜单获取数据]
         * @param   {[type]}  node  [node description]选中的节点
         * @return  {[type]}        [return description]
         */
        $scope.showSelectedArea = function (node) {
            var defer = $q.defer();
            resourceCenterService.getArea(node).then(function (data) {
                defer.resolve(data);
            });
            return defer.promise;
        };

        /**
         * [getFilterVal description] 获取过滤信息
         * @param   {[type]}  key   [key description] 参数类型
         * @param   {[type]}  val   [val description] 需要的过滤数据
         * @param   {[type]}  val2  [val2 description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.getFilterVal = function (key, val, val2) {
            switch (key) {
                case 'area':
                    $scope.data.area = val; // 当前选中的地域数组信息
                    // 获取ID
                    $scope.keyword.area = val[0][val[0].length - 1].id;
                    break;
                case 'time':
                    // 获取开始和结束时间
                    var st = $scope.data.untildate.replace(new RegExp('-', 'gm'), '/');
                    var et = $scope.data.fromdate.replace(new RegExp('-', 'gm'), '/');
                    if (st == '' && et == '') {
                        $scope.keyword.time = '';
                    } else {
                        $scope.keyword.time = st + ',' + et;
                    }
                    if ($scope.status.isrepetite && st == '') {
                        return;
                    }
                    break;
                case 'zyzxfield':
                    // 获取主题
                    $scope.keyword.zyzxfield = val;
                    break;
                case 'doctype':
                    // 获取文件类型
                    $scope.keyword.menuscriptType = val;
                    if (val === '2') {
                        $scope.status.hasphoto = true;
                    } else {
                        $scope.status.hasphoto = false;
                    }
                    break;
                case 'keyword':
                    // 获取文件类型
                    $scope.keyword.keywords = val;
                    $scope.keyword.searchType = $scope.data.keyType.curValue.value;
                    break;
            }
            if ($scope.data.fromdate == '') {
                $scope.status.isrepetite = true;
            } else {
                $scope.status.isrepetite = false;
            }
            clearPageData();
            // 刷新列表
            requestData();
        };

        /**
         * [clearPageData description] 清除列表数据
         * @return  {[type]}  [return description]
         */
        function clearPageData() {
            $scope.params.pageNum = 1;
            $scope.data.items = [];
            $scope.data.selectedArray = [];
        }

        /**
         * [dateFormat description] 日期格式处理
         * @param   {[type]}  date  [date description]
         * @return  {[type]}        [return description]
         */
        function dateFormat(date) {
            var year = date.getFullYear();
            year = year < 10 ? '0' + year : year + '';
            var month = date.getMonth() + 1;
            month = month < 10 ? '0' + month : month + '';
            var day = date.getDate();
            day = day < 10 ? '0' + day : day + '';

            return year + '-' + month + '-' + day;
        }

        /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            $scope.data.selectedArray = []; // 清空之前的选择数据
            if (!$scope.data.fromdata && !$scope.data.untildate) {
                var date = new Date();
                $scope.data.untildate = dateFormat(date);

                var tmp = date.getTime() - 1000 * 60 * 60 * 24 * 3;

                var threeBeforeDate = new Date(tmp);
                $scope.data.fromdate = dateFormat(threeBeforeDate);
            }
            if ($scope.status.isSzbPage) {
                requestPreviewData();
            } else {
                $scope.keyword.isHead = $scope.status.isHead ? '1' : ''; // 是：传1，否：传空
                $scope.params.keyword = JSON.stringify($scope.keyword);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function (data) {
                    $scope.data.headers = data.summary_info.hybaseField; // 表头信息
                    $scope.page = data.summary_info; // 分页信息
                    $scope.basicParams.indexName = data.summary_info.indexName;
                    // 循环数组 给数据加上序号
                    for (var i = 0; i < data.content.length; i++) {
                        data.content[i].NUMBER = (($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE + i + 1).toString();
                    }
                    // 是否图集稿
                    if ($scope.status.hasphoto) {
                        $scope.data.itemCounts = 0;
                        $scope.status.multiImgsReady = false;
                        $scope.data.items = data.content;
                        // $scope.data.items = $scope.data.items.concat(data.content);
                    } else {
                        $scope.data.items = data.content;
                    }
                    storageListenerService.previewPageTurningStorage($scope.data.items, 'ZB_GUID', 'resourceDetail');
                    getImgList(data.content);
                });
            }
        }

        /**
         * [requestPreviewData description] 请求数字报版面列表
         * @return {[type]} [description]
         */
        function requestPreviewData() {
            var keyword = {
                time:
                    $filter('date')($scope.data.fromdate, 'yyyyMMdd') || ''.toString()
                        ? $filter('date')($scope.data.fromdate, 'yyyyMMdd').toString() +
                        ',' +
                        $filter('date')($scope.data.untildate, 'yyyyMMdd').toString()
                        : '',
                keywords: $scope.keyword.mediaName,
            };
            var params = {
                serviceid: 'epaper', // jtcpg
                typeId: 'zyzx',
                modelid: 'getBmList',
                pageSize: 12,
                pageNum: $scope.page.CURRPAGE,
                keyword: JSON.stringify(keyword),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                $scope.data.previewItems = data.content;
                storageListenerService.previewPageTurningStorage($scope.data.previewItems, 'ZB_GUID', 'resourceDetail');
                $scope.page = data.summary_info;
            });
        }

        /**
         * [dealPic description] 数字报版面样式-重新拷贝图片路径并加上随机数，使每次发起不同的请求
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.dealPic = function (item) {
            item.IR_JPPATH = item.IR_JPPATH + '?random=' + Math.random();
        };

        /**
         * [toPreviewDetail description] 数字报版面样式-初始化请求数据
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.toPreviewDetail = function (item) {
            var router;
            router = $state.href('digitaldetailother', {
                nodeid: item.IR_ORDER,
                bc: item.BC,
                docpubtime: item.IR_URLTIME,
                serviceid: $scope.params.serviceid,
                papername: item.IR_SITENAME,
            });
            window.open(router + '&' + Math.random());
        };

        /**
         * [getImgList description] 请求图片数据
         * @param   {[type]}  list  [list description]
         * @return  {[type]}        [return description]
         */
        function getImgList(list) {
            var docIds = trsspliceString.spliceString(list, 'ZB_GUID', ',');
            if (docIds) {
                var params = {
                    typeid: 'zyzx',
                    modelid: 'getImgList',
                    serviceid: $scope.basicParams.channelName,
                    channelName: $scope.basicParams.channelName,
                    guids: docIds,
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                    if (data.result === 'success') {
                        var temp = data.content[0];
                        var index = 0;
                        // var index = $scope.status.hasphoto ? ($scope.params.pageNum - 1) * $scope.params.pageSize : 0; // 这是为了使用滚动加载不用再遍历循环添加imgurl
                        for (var i = index; i < $scope.data.items.length; i++) {
                            var value = $scope.data.items[i];
                            if (!value.imgurl) {
                                value.width = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS[0].wight;
                                value.height = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS[0].height;
                                value.imgurl = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS;
                            }
                        }
                        $scope.status.multiImgsReady = true;
                        for (var j = 0; j < $scope.data.items.length; j++) {
                            if (!$scope.data.items[j].lastLineHide) {
                                $scope.data.itemCounts++;
                            }
                        }
                        $timeout(function () {
                            initOperFlag();
                        });
                    }
                });
            }
        }

        /**
         * [selectAll description] 全选
         * @return  {[type]}  [return description]
         */
        $scope.selectAll = function () {
            $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description] 单选
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.selectDoc = function (item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [pageChanged description]分页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            $scope.params.pageNum = $scope.page.CURRPAGE;
            $scope.data.currPage = $scope.page.CURRPAGE;
            requestData();
            resourceCenterService.scrollTop($element);
        };
        $scope.selectPageNum = function () {
            $scope.params.pageNum = $scope.page.CURRPAGE;
            $scope.data.currPage = $scope.page.CURRPAGE;
            $scope.params.pageSize = $scope.page.PAGESIZE;
            requestData();
            resourceCenterService.scrollTop($element);
        };
        $scope.jumpToPage = function () {
            $scope.params.pageNum = $scope.data.currPage;
            $scope.page.CURRPAGE = $scope.data.currPage;
            requestData();
            resourceCenterService.scrollTop($element);
        };

        /**
         * [singleGraphMode description] 是否为单图模式
         * @return {[type]} [description]
         */
        $scope.singleGraphMode = function () {
            $scope.page.CURRPAGE = 1;
            $scope.params.pageNum = $scope.page.CURRPAGE;
            $scope.data.items = [];
            $scope.status.singleGraph = !$scope.status.singleGraph;
            requestData();
        };

        /**
         * [loadMore description] 图集-加载更多图片
         * @return {[type]} [description]
         */
        $scope.imgLoadMore = function () {
            $scope.page.CURRPAGE++;
            $scope.params.pageNum = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [isSzbPage description] 切换数字报版面样式
         * @return {Boolean} [description]
         */
        $scope.isSzbPage = function () {
            $scope.$broadcast('getTrsHeight');
            $scope.status.isSzbPage = !$scope.status.isSzbPage;
            // 重置状态
            $scope.data.themeType.curValue = $scope.data.themeType.data[0];
            $scope.status.screenWrapSelected = false;
            $scope.status.hasphoto = false;
            $scope.data.keyType.curValue = $scope.data.keyType.data[0];
            $scope.data.docType.curValue = $scope.data.docType.data[0];
            $scope.data.casDataArea = [];
            $scope.params.keyword = {
                searchType: '0', // 查询类型
                keywords: '', // 关键词
                time: '', // 时间范围
                area: '', // 地域
                zyzxfield: '', // 主题
                isOriginal: '', // 是否原创
                isHead: '', // 是否头版
                isRead: '', // 是否10w+
                menuscriptType: '', // 稿件类型
            };
            // $scope.data.fromdate;
            // $scope.data.untildate;
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.setResourceCenterPageSize,
            };
            $scope.data.items = [];
            $scope.data.previewItems = [];
            resourceCenterService.setSzbPage($scope.status.isSzbPage);
            requestData();
        };

        /**
         * [quickPreview description] 快速预览模式
         * @return {[type]} [description]
         */
        $scope.quickPreview = function () {
            $scope.params.keyword = JSON.parse($scope.params.keyword);
            $scope.$root.filterData = {
                page: $scope.page, // 分页
                paramsKeyword: $scope.params.keyword, // 其他条件
                area: $scope.data.area, // 地域信息
                docType: $scope.data.docType, // 当前稿件类型
                themeType: $scope.data.themeType, // 当前主题
                keyType: $scope.data.keyType, // 当前检索信息
                isHead: $scope.status.isHead, // 只看头版
            };
            if ($scope.data.fromdate && $scope.data.fromdate != '') {
                $scope.$root.filterData.fromdate = $scope.data.fromdate; // 开始时间
                $scope.$root.filterData.untildate = $scope.data.untildate; // 结束时间
            }
            if ($scope.status.hasphoto) {
                // 是否图集稿，是则直接传递图集列表数据
                $scope.$root.filterData.listData = $scope.data.items;
                $scope.$root.filterData.singleGraph = $scope.status.singleGraph; // 是否单图
            }
            $state.go('front.networksource.classifiedresource.digital.quickpreview', $stateParams);
        };

        /**
         * [viewBigDataInfo description] 取签见撤重 点击弹出
         * @param   {[type]}  ChnlDocId   [ChnlDocId description] 稿件id
         * @param   {[type]}  showRepeat  [showRepeat description] 类型
         * @param   {[type]}  showClick   [showClick description]
         * @return  {[type]}              [return description]
         */
        $scope.viewBigDataInfo = function (ChnlDocId, showRepeat, showClick) {
            var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
            var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
        };

        /**
         * [initOperFlag description] 初始化取签见撤重
         * @return  {[type]}  [return description]
         */
        function initOperFlag() {
            var docIds = trsspliceString.spliceString($scope.data.items, 'ZB_GUID', ',');
            if (docIds) {
                var params = {
                    methodname: 'queryFlag',
                    serviceid: 'mlf_bigdataexchange',
                    guids: docIds,
                };
                params = angular.extend(params, $scope.basicParams);
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    $scope.data.operFlags = [];
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                            $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                        }
                    }
                });
            }
            $scope.data.selectedArray = [];
        }

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description]
         * @param  {[type]} flagIndex [description]
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function (guid, flagIndex) {
            var temp = queryItemBYGUID(guid);
            if (!!temp) {
                return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == '1';
            } else {
                return false;
            }
        };

        /**
         * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} guid [description]
         * @return {[type]}      [description]
         */
        function queryItemBYGUID(guid) {
            for (var i in $scope.data.operFlags) {
                if (guid == $scope.data.operFlags[i].GUID) {
                    return $scope.data.operFlags[i];
                }
            }
        }

        /**
         * [determineSelected description] 判断是否有选中稿件
         * @return  {[type]}  [return description]
         */
        function determineSelected() {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                return false;
            } else {
                return true;
            }
        }

        /**
         * [openTakeDraftModal description] 取稿
         * @return  {[type]}  [return description]
         */
        $scope.openTakeDraftModal = function () {
            if (!determineSelected()) {
                return;
            }
            var params = {
                methodname: 'fetch',
                channelName: $scope.basicParams.channelName,
                indexName: $scope.basicParams.indexName,
                serviceid: 'mlf_bigdataexchange',
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
            };
            var modalInstance = resCtrModalService.fullTakeDraft(params, true);
            modalInstance.result.then(
                function (data) {
                    takeDraftDownloadImgs(data).then(function () {
                        initOperFlag();
                    });
                },
                function () {
                    initOperFlag();
                }
            );
        };

        /**
         * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function takeDraftDownloadImgs(data) {
            var deferred = $q.defer();
            var needDownloadImg = false;
            for (var i = 0; i < data.REPORTS.length; i++) {
                if (data.REPORTS[i].PICERROR == 1) {
                    needDownloadImg = true;
                    break;
                }
            }
            if (needDownloadImg) {
                resCtrModalService.takeDraftDownloadImgs(data, function (res) {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        /**
         * [CreationAxis description] 个人素材
         * @return  {[type]}  [return description]
         */
        $scope.CreationAxis = function () {
            if (!determineSelected()) {
                return;
            }
            var params = {
                typeid: 'zyzx',
                serviceid: 'mlf_bigdataexchange',
                PersonalMaterialId: 0,
                channelName: $scope.basicParams.channelName,
                typeName: $stateParams.typename,
                indexName: $scope.basicParams.indexName,
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                modelid: 'creation',
            };
            params.guid = trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ',');
            resourceCenterService.setBigDataCreation(params).then(function (data) {
                modalDialog.alertType('添加成功!', '', 'success', false, function () {
                    $scope.data.selectedArray = [];
                });
            });
        };

        /**
         * [collect description] 收藏
         * @return {[type]} [description]
         */
        $scope.collect = function () {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                return;
            }
            var params = {
                methodname: 'collect',
                indexName: $scope.basicParams.indexName,
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
            };
            params = angular.extend(params, $scope.headerClick);
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                modalDialog.alertType('收藏成功!', '', 'success', false, function () {
                    $scope.data.selectedArray = [];
                });
            });
        };

        /**
         * [openReserveDraftModal description] 预留
         * @return  {[type]}  [return description]
         */
        $scope.openReserveDraftModal = function () {
            if (!determineSelected()) {
                return;
            }
            var resCtrModalServiceModal = resCtrModalService.reserveDraft($scope.data.selectedArray);
            resCtrModalServiceModal.result.then(function (result) {
                delete result.items;
                var params = {
                    typeid: 'zyzx',
                    serviceid: 'mlf_bigdataexchange',
                    channelName: $scope.basicParams.channelName,
                    indexName: $scope.basicParams.indexName,
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                    methodname: 'delay',
                };
                params = angular.extend(params, result);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function (data) {
                        modalDialog.alertType('预留成功!', '', 'success', false, function () {
                            initOperFlag();
                        });
                    },
                    function () { }
                );
            });
        };

        /**
         * [printbtn description]打印
         * @return  {[type]}  [return description]
         */
        $scope.printbtn = function () {
            if (!determineSelected()) {
                return;
            }
            var params = {
                serviceid: $scope.basicParams.channelName,
                modelid: 'detailData',
                guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                channelName: $scope.basicParams.channelName,
                typeid: 'zyzx',
                indexName: $scope.basicParams.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                trsPrintService.trsPrintBigData(data);
            });
        };

        /*
         * [export description]导出
         * @return  {[type]}  [return description]
         */
        $scope.export = function () {
            if (!determineSelected()) {
                return;
            }
            var params = {
                serviceid: 'mlf_exportword',
                methodname: 'exportBigDataDocs',
                GUIDS: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                CHANNELNAMES: $scope.basicParams.channelName,
                indexName: $scope.basicParams.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
            });
        };

        /**
         * [scrollShowMore description] 滚动加载更多图片
         * @return {[type]} [description]
         */
        // $scope.scrollShowMore = function() {
        //     if ($scope.status.hasphoto) {
        //         $scope.imgLoadMore();
        //     }
        // };

        /**
         * [openPageForSearch description] 打开高级检索新页面
         * @return {[date]} [description]
         */
        $scope.openPageForSearch = function () {
            var url = $state.href('resadvancedsearch');
            window.open(url, '_blank');
        };

        /**
         * [goToDetail description]细览页跳转
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.goToDetail = function(item) {
            var urlParams = {guid: item.ZB_GUID, channel: $scope.basicParams.channelName, indexname: $scope.basicParams.indexName};
            var url = $state.href('resourcedetail', urlParams);
            window.open(url);
        };
    },
]);
